import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as e } from "@mui/material";
const n = () => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 12.17 8.83 9l-1.41 1.41L12 15l4.59-4.59L15.17 9z",
        clipRule: "evenodd"
      }
    )
  }
), t = (l) => /* @__PURE__ */ o(e, { ...l, children: /* @__PURE__ */ o(n, {}) });
export {
  t as A
};
